/**
 * Возврат из Google.
 *
 * Токен приходит во фрагменте адреса, а не в запросе: фрагмент не уходит на
 * сервер, не попадает в журналы прокси и не утекает в Referer. Экран забирает
 * его оттуда и сразу чистит адресную строку — чтобы он не остался в истории
 * браузера и не уехал вместе со скриншотом.
 *
 * Если человек попал в аккаунт, заведённый раньше по коду на почту, он об
 * этом узнаёт. Молчаливое слияние двух входов в один аккаунт выглядит как
 * потеря данных, даже когда ничего не потеряно.
 */
import { useT } from '@allswipes/i18n';
import { Card, Skeleton } from '@allswipes/ui';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { api } from '../api';
import { useSession } from '../session';
import { Shell } from '../components/Shell';

export function GoogleReturnScreen() {
  const t = useT();
  const navigate = useNavigate();
  const { refresh } = useSession();
  const [linked, setLinked] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = hash.get('token');
    if (!token) {
      setFailed(true);
      return;
    }
    api.setToken(token);
    // Чистим адрес до любого перехода: токен не должен остаться в истории.
    window.history.replaceState(null, '', '/auth/google');

    const wasLinked = hash.get('linked') === '1';
    const next = hash.get('next') || '/';
    setLinked(wasLinked);

    void refresh().then(() => {
      // Со связкой задерживаемся на секунду: человеку надо успеть прочитать,
      // что это его прежний аккаунт, а не новый.
      // Через знакомство: у вошедшего впервые нет ни имени, ни пола, а имя
      // нужно у стойки выдачи приза. Экран сам пропустит себя, если спрашивать
      // нечего — вернувшийся не увидит лишнего шага.
      const to = `/welcome?next=${encodeURIComponent(next)}`;
      window.setTimeout(() => navigate(to, { replace: true }), wasLinked ? 1800 : 0);
    });
  }, [navigate, refresh]);

  return (
    <Shell title={t('Вход')}>
      <Card>
        {failed ? (
          <p className="sub">
            {t('Не получилось завершить вход. Вернись на экран входа и попробуй ещё раз.')}
          </p>
        ) : linked ? (
          <p className="sub">
            {t('Это твой прежний аккаунт: та же почта, что и при входе по коду. Билеты, баллы и призы на месте.')}
          </p>
        ) : (
          <Skeleton count={2} />
        )}
      </Card>
    </Shell>
  );
}
